import { Error } from '@wix/wix-ui-icons-common/on-stage';
import React from 'react';
import { DATA_HOOKS } from '../../../../constants/data-hooks';
import { classes } from './submit-button-wut.st.css';
export const ErrorMessageWUT = _ref => {
  let {
    errorMessage
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.errorMessage,
    "data-hook": DATA_HOOKS.SUBMIT_ERROR_MESSAGE
  }, /*#__PURE__*/React.createElement(Error, {
    className: classes.errorIcon,
    "aria-hidden": "true"
  }), errorMessage);
};
//# sourceMappingURL=error-message-wut.js.map